import type { ApiResponse } from '@abaninja/types';

import { apiClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Connection } from '../@types';

export function getConnections() {
  return createCancellablePromise(
    ({ signal }) => apiClient.get<ApiResponse<Connection[]>>('/deep-cloud/v1/connections', { signal }),
  );
}

export function getConnection(connectionUuid: string) {
  return createCancellablePromise(({ signal }) => apiClient.get<ApiResponse<Connection>>(
    `/deep-cloud/v1/connections/${connectionUuid}`,
    { signal },
  ));
}

export function createConnection(deepCloudOrganizationUuid: string) {
  return apiClient.post<ApiResponse<Connection>>('/deep-cloud/v1/connections', { deepCloudOrganizationUuid });
}

export function deleteConnection(connectionUuid: string) {
  return apiClient.delete(`/deep-cloud/v1/connections/${connectionUuid}`);
}
